<!-- Prompt Enhancement Card — shown when PromptEnhancerMiddleware emits a PROMPT_ENHANCEMENT interrupt -->
<div class="prompt-enhance">

    <!-- ── Header row ─────────────────────────────────────────────── -->
    <div class="prompt-enhance__header theme-bg-light">
        <span class="prompt-enhance__icon-wrap">
            <app-icon type="lightbulb" source="lucide" size="sm" />
        </span>
        <span class="prompt-enhance__label">
            <span class="prompt-enhance__name">Enhanced prompt</span>
            <span class="prompt-enhance__meta">Review before the agent starts</span>
        </span>
    </div>

    <!-- ── Read-only markdown view ────────────────────────────────── -->
    @if (!isEditing()) {
    <div class="prompt-enhance__body">
        <pre class="prompt-enhance__pre">{{ plan().markdown }}</pre>

        <!-- Pencil button — fades in on body hover; enters edit mode on click -->
        <app-button class="prompt-enhance__edit-btn" icon="pencil" [iconSource]="'lucide'" variant="outlined" size="xs"
            pTooltip="Edit prompt" tooltipPosition="left" (clicked)="enterEditMode()" />
    </div>

    <!-- Feedback input row -->
    <div class="prompt-enhance__feedback-row">
        <div class="prompt-enhance__feedback">
            <!-- No [rows] → renders as a single-line <input> instead of a <textarea> -->
            <app-input class="prompt-enhance__feedback-textarea" [ngModel]="feedbackText()"
                (ngModelChange)="feedbackText.set($event)" (keydown)="onFeedbackKeydown($event)"
                [disabled]="isRevising()" placeholder="Ask AI to modify this prompt…" />
            <app-button class="prompt-enhance__feedback-send" [icon]="'arrow-up'" [iconSource]="'lucide'" size="sm"
                [loading]="isRevising()" [disabled]="!feedbackText().trim() || isRevising()"
                (clicked)="submitFeedback()" />
        </div>
    </div>

    <!-- Action bar: timer + Approve (right) -->
    <div class="prompt-enhance__actions">
        <div class="prompt-enhance__approve-wrap">
            @if (isTimerActive()) {
            <span class="prompt-enhance__timer" [class.prompt-enhance__timer--urgent]="timeRemaining() <= 10">
                Auto start in {{ formatTime(timeRemaining()) }}
            </span>
            }
            <app-button label="Approve &amp; start" size="sm" severity="primary" (clicked)="onApprove()" />
        </div>
    </div>
    }

    <!-- ── Markdown edit mode ──────────────────────────────────────── -->
    @if (isEditing()) {
    <div class="prompt-enhance__body prompt-enhance__body--edit">
        <textarea class="prompt-enhance__editor" [(ngModel)]="editableMarkdown"
            placeholder="Edit the enhanced prompt…"></textarea>
    </div>
    <div class="prompt-enhance__actions">
        <app-button label="Cancel" variant="outlined" size="sm" (clicked)="cancelEdit()" />
        <app-button label="Proceed with edits" size="sm" severity="primary" [icon]="'check'" [iconSource]="'lucide'"
            [disabled]="!hasEdits()" (clicked)="onEditApprove()" />
    </div>
    }
</div>
